export default __webpack_public_path__ + "static/media/424431.606ed15c.svg";